import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, CardHeader, Box } from '@mui/material';
//
import { BaseOptionChart } from '../../charts';
import {  useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------

const CHART_DATA = [
  {
    name: 'Team A',
    // type: 'line', //'column',
    data: [
        { x: new Date('2018-02-12').getTime(), y: 76 }, 
        { x: new Date('2018-02-15').getTime(), y: 22 },
        { x: new Date('2018-03-15').getTime(), y: 22 },
        { x: new Date('2018-03-15').getTime(), y: 0 },
    ]
  }
  
];

export default function AppChart(props) {
//  const chartOptions = merge(BaseOptionChart(), );
  const {t} = useTranslation();
  const chartOptions = {
    chart: {
        type: 'area',
        stacked: false,
        height: 450,
        zoom: {
          type: 'x',
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          
          autoSelected: 'zoom'
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 0,
      },
      stroke: {
        width: 2,
        curve: 'smooth'
      },
      // fill: {
      //   type: 'gradient',
      //   gradient: {
      //     shadeIntensity: 1,
      //     inverseColors: false,
      //     opacityFrom: 1,
      //     opacityTo: 1,
      //     stops: [0, 90, 100]
      //   },
      // },
      yaxis: {
        labels: {
          formatter: function (val) {
            return (val ).toFixed(0);
          },
        },
        title: {
          text: t('linechart_y_label'),
          style : {
            color : 'blue'
          }
        },
      },
      xaxis: {
        type: 'datetime',
      },
      tooltip: {
        shared: false,
        y: {
            formatter: function (val) {

                if (val === undefined)
                    return 0;
                return (val ).toFixed(0)
            }
        }
      }
  };

    if (props.data == null){
        return <div></div>
    }



    //   [
    //     { x: new Date('2018-02-12').getTime(), y: 76 }, 
    //     { x: new Date('2018-02-15').getTime(), y: 22 },
    //     { x: new Date('2018-03-15').getTime(), y: 22 },
    //     { x: new Date('2018-03-15').getTime(), y: 0 },
    // ]

  return (
      <Box sx={{ p: "20px", pb: 1, pt:0 }} dir="ltr">
        <ReactApexChart type="line" series={props.data} options={chartOptions} height={props.height} />
      </Box>
 
  );
}
